import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { FamilyVM } from 'shell/view-models/family-member';
import { DateTime } from 'luxon';
import { CadastralData, FamilyDatas, ResponseAnprData, SubjectData } from 'shell/models/person';
import { AnprVM } from 'shell/view-models/search-anpr';

export const transformFamilyMember = (item: SubjectData): FamilyVM => {
  let birthplace = '';
  // birthplace check for object
  if (item.generalita?.luogoNascita?.localita) {
    birthplace = `${item.generalita?.luogoNascita?.localita.descrizioneLocalita} (${item.generalita?.luogoNascita?.localita.descrizioneStato})`;
  }

  if (item.generalita?.luogoNascita?.comune) {
    birthplace = `${item.generalita?.luogoNascita?.comune.nomeComune} (${item.generalita?.luogoNascita?.comune.siglaProvinciaIstat})`;
  }
  // Residence check for object
  let residence = '';
  // scelgo il primo o è un array?
  if ((item.residenza || [])[0]?.indirizzo) {
    residence = `${(item.residenza || [])[0]?.indirizzo?.comune?.nomeComune || ''} (${
      (item.residenza || [])[0]?.indirizzo?.comune?.siglaProvinciaIstat || ''
    })`;
  }
  // scelgo il primo o è un array?
  if ((item.residenza || [])[0]?.localitaEstera) {
    const descrizioneStato =
      (item.residenza || [])[0]?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato || '';
    const descrizioneConsolato =
      (item.residenza || [])[0]?.localitaEstera?.consolato?.descrizioneConsolato || '';
    residence = [descrizioneStato, descrizioneConsolato].filter(Boolean).join(' ');
  }

  let state = '';
  // state check for object
  if (item.generalita?.soggettoAIRE && item.generalita?.soggettoAIRE === 'S') {
    state = 'Iscritto AIRE';
  }

  if (item.datiCancellazione) {
    state = `${item.datiCancellazione.motivoCancellazione}`;
  }

  if ((item.residenza || [])[0]?.indirizzo?.toponimo) {
    const toponym = (item.residenza || [])[0]?.indirizzo?.toponimo;

    const civic = (item.residenza || [])[0]?.indirizzo?.numeroCivico;

    state = `${toponym?.specie} ${toponym?.denominazioneToponimo},${civic?.numero}${
      civic?.esponente1 ? `/${civic?.esponente1}${civic?.lettera || ''}` : ''
    }`;
  }
  return {
    fiscalCode: item.generalita?.codiceFiscale?.codFiscale || '',
    gender: item.generalita?.sesso || '',
    idAnprFamily: item.famigliaConvivenza?.idFamigliaConvivenzaANPR || '',
    idMunicipalityFamily:
      item.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenza || '',
    name: item.generalita?.nome || '',
    surname: item.generalita?.cognome || '',
    placeBirth: birthplace,
    relationship: item.legameSoggetto?.descrizioneCodiceLegame || '',
    relationshipCode: item.legameSoggetto?.codiceLegame || '',
    residence: residence || '',
    state,
    dateBirth: item.generalita?.dataNascita
      ? DateTime.fromISO(item.generalita?.dataNascita).toFormat('dd/MM/yyyy')
      : '',
    subject3002: item,
  };
};

export const transformFamilyMembers = (
  httpResponse: AxiosResponse<HttpResponse<ResponseAnprData>>
): AnprVM<FamilyVM> & { datiFamigliaConvivenza?: FamilyDatas; datiCatastali?: CadastralData } => {
  const data = httpResponse.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];
  const datiFamigliaConvivenza = httpResponse.data.payload?.risposta3002OK?.datiFamigliaConvivenza;
  const datiCatastali = httpResponse.data.payload?.datiCatastali;
  const familyMembers: Array<FamilyVM> = data.map((item) => {
    return transformFamilyMember(item);
  });

  return {
    warnings: (httpResponse.data.payload?.risposta3002OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (httpResponse.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: familyMembers,
    datiFamigliaConvivenza,
    datiCatastali,
  };
};
